export default "__VITE_ASSET__Cv1VQpOW__"